/* eslint-disable */
export default {
  DirectNumber: 'Directo',
  MainCompanyNumber: 'Principal',
  CompanyNumber: 'Empresa',
  CompanyFaxNumber: 'Fax',
  Blocked: 'Bloqueado',
  AdditionalCompanyNumber: 'Empresa',
  ForwardedCompanyNumber: 'Desviada',
  from: 'De',
} as const;

// @key: @#@"DirectNumber"@#@ @source: @#@"Direct"@#@
// @key: @#@"MainCompanyNumber"@#@ @source: @#@"Main"@#@
// @key: @#@"CompanyNumber"@#@ @source: @#@"Company"@#@
// @key: @#@"CompanyFaxNumber"@#@ @source: @#@"Fax"@#@
// @key: @#@"Blocked"@#@ @source: @#@"Blocked"@#@
// @key: @#@"AdditionalCompanyNumber"@#@ @source: @#@"Company"@#@
// @key: @#@"ForwardedCompanyNumber"@#@ @source: @#@"Forwarded"@#@
// @key: @#@"from"@#@ @source: @#@"From"@#@
